import { Badge } from '@chakra-ui/react'

export const PartnerBadge: React.FC = () => {
  return (
    <Badge bg="gray.100" color="gray.700">
      P
    </Badge>
  )
}
